module.exports = __webpack_public_path__ + "static/media/sub-card-label-5-over.77f91be0.svg";